import type { ReactNode } from "react";
import classNames from "classnames";

interface WrapperProps {
    children: ReactNode;
    className?: string; // Extra classes from the parent, e.g. "flex-1 my-10"
}

// Page-width container with the site's horizontal padding
const Wrapper = ({ children, className }: WrapperProps) => {
    return (
        <div
            className={classNames(
                "max-w-screen w-full mx-auto lg:pr-28 pt-2 pb-2 pr-8 pl-8 lg:pl-28",
                className
            )}
        >
            {children}
        </div>
    );
};

export default Wrapper;